/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './ResetPasswordInvalid.style';

import LazyLoginMain from 'src/shared/app/authentication/component/login/LazyLoginMain';
import LazyPasswordSupportMain from 'src/shared/app/authentication/component/support/password/LazyPasswordSupportMain';
import forgotMessages from 'src/shared/app/authentication/l10n/forgotPasswordL10n';
import resetMessages from 'src/shared/app/authentication/l10n/resetPasswordL10n';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import {
  passwordSupportRoute,
  loginRoute,
} from 'src/shared/app/base/route/setting/routeSettings';
import PrimaryButton from 'src/shared/ui/component/button/PrimaryButton';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';
import InstructionText from 'src/shared/ui/component/text/InstructionText';
import Subheading from 'src/shared/ui/component/text/Subheading';

const useStyles = createUseStyles(styles);

const ResetPasswordInvalid = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [passwordSupportPath, loginPath] = useRoutes(
    passwordSupportRoute,
    loginRoute,
  );

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onPasswordMouseOver = () => LazyPasswordSupportMain.preload();
  const onLogInMouseOver = () => LazyLoginMain.preload();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  return (
    <div className={classes.root}>
      <Subheading withError>
        {intl.formatMessage(resetMessages.expiredError)}
      </Subheading>
      <InstructionText>
        {intl.formatMessage(resetMessages.error)}
      </InstructionText>
      <div className={classes.action}>
        <PrimaryButton
          large
          href={passwordSupportPath}
          handleMouseOver={onPasswordMouseOver}
        >
          {intl.formatMessage(forgotMessages.logInHint)}
        </PrimaryButton>
      </div>
      <div className={classes.action}>
        <SecondaryButton
          large
          href={loginPath}
          handleMouseOver={onLogInMouseOver}
        >
          {intl.formatMessage(forgotMessages.logInLink)}
        </SecondaryButton>
      </div>
    </div>
  );
};

export default compose(React.memo)(ResetPasswordInvalid);
